import APIBase from "./APIBase";

/**
 * @typedef Product
 * @property {string} VoucherCode
 */


/**
 * @typedef VouchersService
 * @type {VouchersService}
 */
export class VouchersService extends APIBase {
/**
     * @param {string} apiUrl
     * @param { import("../Stores/SessionStore").SessionStore } sessionStore
     **/
    constructor(apiUrl, sessionStore) {
        super(apiUrl + "Vouchers", sessionStore);
    }

    /**
     * @returns { import("./APIBase").EnumerableRequestResult<Product> }
     */
    async VerifyVoucherCode(customerId, voucherCode) {
        return this.Get(`VerifyVoucherCode?customerId=${encodeURIComponent(customerId)}&voucherCode=${encodeURIComponent(voucherCode)}`);
    }
}